import * as React from 'react';
import * as PropTypes from 'prop-types';
import styles from './PageContentWrapper.module.scss';
export default function PageContentWrapper({ children }) {
  return <div className={styles.contentContainer}>{children}</div>;
}
PageContentWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
